const Unauthorized = () => {
    return(
        <h1>Não Autorizado</h1>
    )
}

export default Unauthorized;
